export default __webpack_public_path__ + "static/joanna-a77411ae329bf80be39994963b665a77.jpg";